<template>
    <div class=''>
        <loading ref="loading"></loading>
        <b-modal centered ref="documentDownloadDialog" title="" size="lg">
			<div class="text-center">
				<p v-if='!in_document_download || !in_document_download.data'>{{ $t('translations.preparing_download') }}</p>
                <div v-else class="d-flex flex-column mr-1 align-items-center">
                    <img class='thumbnail-image border align-self-center' src='/img/icon-document.svg' width='50' height='50'>
                    <p class='align-self-center'>{{in_document_download.name}}</p>
                    <a v-on:click='initDocumentDownload($event, in_document_download, in_document_download.name)' v-if='in_document_download.data && thread && thread.user' class='btn btn-lg btn-primary' :href='in_document_download.data' :download='in_document_download.name'>{{ $t('translations.download') }}</a>
                </div>
			</div>
			<!-- <img :width='full_image.width' :height='full_image.height' style='max-width: 100%; max-height: 100%;' :src='full_image.data'> -->
			<div slot="modal-footer" class="w-100">
                <b-btn size="sm" class="float-right" variant="primary" v-on:click.prevent='$refs.documentDownloadDialog.hide()'>
					{{ $t('translations.close') }}
				</b-btn>
			</div>
		</b-modal>
    </div>
</template>

<script>
	export default {
        extends: app.base.attachmentHelper,
		props: {
            in_document_download: {
                default: null
            },
            thread: {
                default: null
            }

            
		},
		data: function(){
			return {
			};
		},
		computed: {
            
        },
		mounted() {

        },
        watch: {

        },
		methods: {
            show() {
                this.$refs.documentDownloadDialog.show();
            },
            hide() {
                this.$refs.documentDownloadDialog.hide();
            },
        }
    }
</script>
